import { render, staticRenderFns } from "./SendToQuarantine.vue?vue&type=template&id=7dfbf08d&"
import script from "./SendToQuarantine.vue?vue&type=script&lang=js&"
export * from "./SendToQuarantine.vue?vue&type=script&lang=js&"
import style0 from "./SendToQuarantine.vue?vue&type=style&index=0&id=7dfbf08d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports